import { Category } from "./category";
import { JsonProperty } from "../requests/jsonparser";
import { BPMPlaylist } from "./bpmplaylist";

export class BPMPlaylistCategory extends Category {

    @JsonProperty({ type: 'string' })
    name: string;

    @JsonProperty({ type: 'string' })
    slug: string;

    @JsonProperty({ type: 'number' })
    order: number;

    @JsonProperty({ type: 'string?' })
    image_url?: string;

    @JsonProperty({ type: 'BPMPlaylist', clazz: BPMPlaylist })
    sets: BPMPlaylist[];

}


// WEBPACK FOOTER //
// ./src/api/src/models/bpmplaylist_category.ts